import styled from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

const backgroundProps = (props: ThemeProp & ShimmerProps) => {
  return `background: ${props.backgroundColor ? props.backgroundColor : props.theme.gradients.shimmer};
      background-size: ${props.verticalAnimation ? '100% 2000px' : '1000px 100%'};`;
};

// Custom shimmer components to replace react-shimmer-effects library
// The library was causing 40-60% CPU usage due to JavaScript-based background-position animations

interface ShimmerProps {
  width?: string;
  height?: string;
  marginTop?: string;
  marginBottom?: string;
  marginRight?: string;
  borderRadius?: string;
  opacity?: string;
  disableFlex?: boolean;
  backgroundColor?: string;
  verticalAnimation?: boolean;
  $justifyFlexEnd?: boolean;
}

export const ShimmerImage = styled.div<ShimmerProps>`
  ${(props: ThemeProp & ShimmerProps) => backgroundProps(props)}
  display: block;
  min-width: unset;
  margin-bottom: ${(props: ShimmerProps) => props.marginBottom || '0px'};
  width: ${(props: ShimmerProps) => props.width || '100%'};
  height: ${(props: ShimmerProps) => props.height || '100%'};
  border-radius: ${(props: ShimmerProps) => props.borderRadius || '4px'};
`;

// Shimmer animation completely removed to fix CPU performance issue
// Previously: CSS keyframes + react-shimmer-effects library both caused issues
// - CSS keyframes: animationiteration events monitored by New Relic
// - react-shimmer-effects: JavaScript-based background-position manipulation
// Both were causing 40-60% CPU usage
// Solution: Custom static shimmer components with no animation

/*const shimmer = keyframes`
 0% {
    background-position: 0 500px;
  }
  100% {
    background-position: 0 -500px;
  }
`;*/

/*animation: ${shimmer} 2.2s linear infinite forwards;*/

export const ShimmerText = styled.div<ShimmerProps>`
  ${(props: ThemeProp & ShimmerProps) => backgroundProps(props)}
  ${({ $justifyFlexEnd }) => $justifyFlexEnd && 'justify-content: flex-end;'};
  ${(props: ShimmerProps) => props.opacity && `opacity: ${props.opacity}`};
  margin-top: ${(props: ShimmerProps) => props.marginTop || '0'};
  margin-bottom: ${(props: ShimmerProps) => props.marginBottom || '0px'};
  margin-right: ${(props: ShimmerProps) => props.marginRight || '0px'};
  height: ${(props: ShimmerProps) => props.height || '1rem'};
  width: ${(props: ShimmerProps) => props.width || '100%'};
  border-radius: ${(props: ShimmerProps) => props.borderRadius || '0'};
  display: block;
`;
